<style lang="scss" scoped>
.empty {
	&__small {
		text-align: center;
		border-radius: 10px;
		font-size: 17px;
		font-weight: 500;
		color: $grey--300;
		i {
			font-size: 1.5em;
			display: block;
			margin-bottom: 20px;
		}
	}
	&__big {
		text-align: center;
		font-size: 20px;
	}
	&__container {
		border-radius: 10px;
		padding: 60px 200px;
		background: $grey--100;
	}
	&__circle {
		img {
			height: 130px;
			width: 130px;
			margin-bottom: 30px;
		}
	}
}
</style>

<template lang="pug">
.empty
    .empty__big(v-if="big")
        .empty__container
            .empty__circle
                img(src="/cross.svg")
            .empty__content
                slot
    .empty__small(v-else, :class="{ '--side-margin' : sideMargin }")
        slot
</template>

<script>
export default {
	name: "Empty",
	props: {
		sideMargin: {
			type: Boolean,
			default: true
		},
		big: {
			type: Boolean,
			default: true
		}
	}
};
</script>
